export const loadings = {
	graph: false,
	buttonSaveGraph: false,
};

export const initGraphSemaforo = {
	allData: [],
	table: [],
	years: [],
	selectYear: "",
	isThisMonthSave: false,
	statusprojectfilter: [],
	selectStatus: [],
};
